module.exports = __webpack_public_path__ + "static/media/more.4f6e94d9.svg";